import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { ITrack } from '../../../../Interface/track'
import { SsrService } from '../../../../services/ssr.service'
import { TracksService } from '../../../../services/tracks.service'

@Component({
  selector: 'bmcore-spotlight-tracks',
  templateUrl: './bmcore-spotlight-tracks.component.html',
  styleUrls: ['./bmcore-spotlight-tracks.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSpotlightTracksComponent implements OnInit {
  pageSize = 10
  tracks: ITrack[] = []

  constructor(
    private tracksService: TracksService,
    private ssrService: SsrService
  ) {}

  ngOnInit(): void {
    this.ssrService.wait('bmcore-spotlight-tracks: tracksService.getSpotlightBeats')
    this.tracksService.getSpotlightBeats(this.pageSize).subscribe(res => {
      this.ssrService.ready('bmcore-spotlight-tracks: tracksService.getSpotlightBeats')
      this.tracks = res.items
    })
  }
}
